var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _g115, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128, _g129, _g130, _g131, _g132, _g133, _g134, _g135, _g136, _g137, _g138, _g139, _g140, _g141, _g142, _g143, _g144, _g145, _g146, _g147, _g148, _g149, _g150, _g151, _g152, _g153, _g154, _g155, _g156, _g157, _g158, _g159, _g160, _g161, _g162, _g163, _g164, _g165, _g166, _g167, _g168, _g169, _g170, _g171, _g172, _g173, _g174, _g175, _g176, _g177, _g178, _g179, _g180, _g181, _g182, _g183, _g184, _g185, _g186, _g187, _g188, _g189, _g190, _g191, _g192, _g193, _g194, _g195, _g196, _g197, _g198, _g199, _g200, _g201, _g202, _g203, _g204, _g205, _g206, _g207, _g208, _g209, _g210, _g211, _g212, _g213, _g214, _g215, _g216, _g217, _g218, _g219, _g220, _g221, _g222, _g223, _g224, _g225, _g226, _g227, _g228, _g229, _g230, _g231, _g232, _g233, _g234, _g235, _g236, _g237, _g238, _g239;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEgypt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 21,
    viewBox: "0 0 35 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "EGYPT_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000036237714819454642920000001242992531609313164_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34.1011 14.0264H0.537109V20.5533H34.1011V14.0264Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000036237714819454642920000001242992531609313164__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000046316558819215351670000015601092702917757884_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M34.1349 20.586H0.505859V14H34.1349V20.586ZM0.573853 20.523H34.0699V14.062H0.573853V20.523Z",
    fill: "black"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000036237714819454642920000001242992531609313164__3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M34.1011 7.50391H0.537109V14.0269H34.1011V7.50391Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000036237714819454642920000001242992531609313164__4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000098925243850644653700000005360937371899872928_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M34.1349 14.0627H0.505859V7.46875H34.1349V14.0627ZM0.573853 13.9998H34.0699V7.53876H0.573853V13.9998Z",
    fill: "white"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000036237714819454642920000001242992531609313164__5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M34.1011 0.976562H0.537109V7.50357H34.1011V0.976562Z",
    fill: "#BC0030"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_8"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000036237714819454642920000001242992531609313164__6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M34.1349 7.53833H0.505859V0.944336H34.1349V7.53833ZM0.573853 7.46832H34.0699V1.01132H0.573853V7.46832Z",
    fill: "#BC0030"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_10"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M17.1355 13.859C17.7765 13.859 18.3895 13.808 18.7485 13.707C18.9025 13.684 18.9025 13.602 18.9025 13.5C19.0545 13.449 18.9765 13.2699 19.0825 13.2699C18.9775 13.3009 18.9515 13.09 18.8245 13.122C18.8245 12.938 18.6425 12.915 18.4905 12.966C18.1855 13.068 17.6445 13.091 17.1355 13.091C16.6235 13.068 16.0865 13.068 15.7765 12.966C15.6265 12.915 15.4465 12.939 15.4465 13.122C15.3195 13.091 15.2945 13.3019 15.1885 13.2699C15.2935 13.2699 15.2175 13.45 15.3665 13.5C15.3665 13.602 15.3665 13.684 15.5265 13.707C15.8775 13.809 16.4925 13.859 17.1355 13.859Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_11"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M17.1352 13.926C16.4422 13.926 15.8522 13.867 15.5062 13.774C15.3282 13.743 15.3072 13.637 15.3032 13.547C15.2232 13.5 15.2052 13.418 15.1962 13.367C15.1922 13.355 15.1882 13.344 15.1842 13.336C15.1802 13.336 15.1722 13.336 15.1702 13.336C15.1412 13.324 15.1192 13.297 15.1212 13.262C15.1252 13.231 15.1542 13.207 15.1872 13.207C15.1912 13.207 15.1952 13.207 15.1992 13.207H15.2032C15.2132 13.207 15.2382 13.176 15.2542 13.16C15.2852 13.121 15.3242 13.07 15.3912 13.055C15.4242 12.903 15.6062 12.844 15.7972 12.903C16.0432 12.985 16.4382 13.001 16.8632 13.016L17.1362 13.028C17.7862 13.028 18.2262 12.989 18.4722 12.903C18.6672 12.84 18.8492 12.903 18.8802 13.063C18.9502 13.083 18.9852 13.126 19.0152 13.161C19.0312 13.177 19.0522 13.204 19.0582 13.208C19.0702 13.208 19.0782 13.208 19.0812 13.208C19.1122 13.208 19.1422 13.231 19.1462 13.263C19.1502 13.298 19.1282 13.326 19.0992 13.337C19.0952 13.337 19.0912 13.333 19.0872 13.333C19.0832 13.337 19.0812 13.337 19.0812 13.337C19.0812 13.337 19.0812 13.337 19.0772 13.337C19.0812 13.341 19.0772 13.353 19.0732 13.368C19.0612 13.419 19.0442 13.501 18.9642 13.548C18.9602 13.638 18.9392 13.743 18.7612 13.775C18.4182 13.867 17.8222 13.926 17.1352 13.926ZM15.3072 13.297C15.3152 13.309 15.3192 13.328 15.3232 13.344C15.3332 13.399 15.3412 13.426 15.3872 13.442C15.4122 13.45 15.4302 13.473 15.4302 13.501C15.4302 13.603 15.4302 13.63 15.5352 13.649C15.8692 13.747 16.4672 13.797 17.1352 13.797C17.8012 13.797 18.3992 13.746 18.7312 13.649C18.8382 13.629 18.8382 13.602 18.8382 13.501C18.8382 13.474 18.8562 13.45 18.8812 13.442C18.9302 13.426 18.9362 13.399 18.9512 13.344C18.9512 13.328 18.9572 13.309 18.9612 13.297C18.9472 13.277 18.9302 13.258 18.9142 13.242C18.8852 13.199 18.8672 13.179 18.8462 13.179C18.8282 13.183 18.8052 13.179 18.7872 13.163C18.7732 13.151 18.7582 13.136 18.7582 13.12C18.7582 13.089 18.7582 13.003 18.6292 13.003C18.5922 13.003 18.5512 13.011 18.5122 13.026C18.2542 13.112 17.8012 13.151 17.1352 13.151L16.8562 13.143C16.4282 13.123 16.0182 13.112 15.7582 13.026C15.7172 13.01 15.6762 13.003 15.6412 13.003C15.5102 13.003 15.5102 13.089 15.5102 13.12C15.5102 13.136 15.5002 13.151 15.4852 13.163C15.4712 13.179 15.4542 13.183 15.4342 13.179C15.3992 13.183 15.3832 13.199 15.3542 13.242C15.3402 13.258 15.3242 13.277 15.3072 13.297Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_12"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M15.6759 13.2188C15.6249 13.2188 15.6249 13.2498 15.6759 13.2498C15.6989 13.2498 15.6989 13.2188 15.6759 13.2188Z",
    fill: "#F4D134"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_13"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M15.6765 13.2846C15.6085 13.2846 15.6064 13.2416 15.6064 13.2336C15.6064 13.2026 15.6495 13.1826 15.6765 13.1826C15.6965 13.1826 15.7274 13.2136 15.7274 13.2336C15.7274 13.2496 15.6955 13.2846 15.6765 13.2846Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_14"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M15.6765 13.1201C15.6495 13.1201 15.6495 13.1671 15.6765 13.1671C15.7275 13.1671 15.7275 13.1201 15.6765 13.1201Z",
    fill: "#F4D134"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_15"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M15.6761 13.199C15.6581 13.199 15.623 13.16 15.623 13.144C15.623 13.124 15.6581 13.085 15.6761 13.085C15.7251 13.085 15.7501 13.116 15.7501 13.144C15.7501 13.172 15.7251 13.199 15.6761 13.199Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_16"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M15.6765 13.5C15.6495 13.5 15.6495 13.551 15.6765 13.551C15.6995 13.551 15.6995 13.5 15.6765 13.5Z",
    fill: "#F4D134"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_17"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask16_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M15.6761 13.5859C15.6581 13.5859 15.623 13.5469 15.623 13.5269C15.623 13.5069 15.6581 13.4639 15.6761 13.4639C15.6961 13.4639 15.7271 13.5069 15.7271 13.5269C15.7271 13.5469 15.6951 13.5859 15.6761 13.5859Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_18"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M15.775 13.5264C15.726 13.5264 15.726 13.5774 15.775 13.5774C15.805 13.5774 15.805 13.5264 15.775 13.5264Z",
    fill: "#F4D134"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_19"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask18_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M15.775 13.6122C15.73 13.6122 15.707 13.5811 15.707 13.5531C15.707 13.5221 15.746 13.4941 15.775 13.4941C15.797 13.4941 15.832 13.5371 15.832 13.5531C15.832 13.5811 15.805 13.6122 15.775 13.6122Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_20"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask19_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M15.8773 13.5508C15.8573 13.5508 15.8573 13.6018 15.8773 13.6018C15.9303 13.6018 15.9303 13.5508 15.8773 13.5508Z",
    fill: "#F4D134"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_21"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask20_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M15.8771 13.6365C15.8611 13.6365 15.8281 13.5975 15.8281 13.5735C15.8281 13.5575 15.8611 13.5186 15.8771 13.5186C15.9281 13.5186 15.9531 13.5495 15.9531 13.5735C15.9531 13.6015 15.9281 13.6365 15.8771 13.6365Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_22"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask21_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M17.4695 13.3008C17.4425 13.3008 17.4425 13.3478 17.4695 13.3478C17.4925 13.3478 17.4925 13.3008 17.4695 13.3008Z",
    fill: "#F4D134"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_23"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask22_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M17.4691 13.3828C17.4461 13.3828 17.4141 13.3438 17.4141 13.3238C17.4141 13.3038 17.4451 13.2607 17.4691 13.2607C17.4861 13.2607 17.5221 13.3038 17.5221 13.3238C17.5221 13.3438 17.4861 13.3828 17.4691 13.3828Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_24"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask23_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M17.4924 13.3975C17.4414 13.3975 17.4414 13.4204 17.4924 13.4204C17.5204 13.4214 17.5204 13.3975 17.4924 13.3975Z",
    fill: "#F4D134"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_25"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask24_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M17.5701 13.6514C17.5431 13.6514 17.5431 13.7064 17.5701 13.7064C17.5941 13.7064 17.5941 13.6514 17.5701 13.6514Z",
    fill: "#F4D134"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_26"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask25_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M17.5705 13.7452C17.5475 13.7452 17.5195 13.7022 17.5195 13.6792C17.5195 13.6592 17.5465 13.6162 17.5705 13.6162C17.5885 13.6162 17.6235 13.6592 17.6235 13.6792C17.6235 13.7022 17.5885 13.7452 17.5705 13.7452Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_27"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask26_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M17.6745 13.6514C17.6215 13.6514 17.6215 13.7064 17.6745 13.7064C17.6955 13.7064 17.6955 13.6514 17.6745 13.6514Z",
    fill: "#F4D134"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_28"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask27_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M17.6737 13.7452C17.6227 13.7452 17.5977 13.7102 17.5977 13.6792C17.5977 13.6522 17.6227 13.6162 17.6737 13.6162C17.6917 13.6162 17.7247 13.6592 17.7247 13.6792C17.7247 13.7062 17.6987 13.7452 17.6737 13.7452Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_29"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask28_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M18.7228 13.4482C18.6718 13.4482 18.6718 13.4792 18.7228 13.4792C18.7478 13.4792 18.7478 13.4482 18.7228 13.4482Z",
    fill: "#F4D134"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_30"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask29_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M18.7234 13.5121C18.6534 13.5121 18.6514 13.4731 18.6514 13.4651C18.6514 13.4341 18.6944 13.4141 18.7234 13.4141C18.7414 13.4141 18.7784 13.4451 18.7784 13.4651C18.7774 13.4841 18.7404 13.5121 18.7234 13.5121Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_31"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask30_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M15.953 13.5461C15.93 13.5461 15.912 13.5421 15.894 13.5341C15.869 13.5261 15.839 13.5181 15.818 13.4991C15.797 13.4991 15.771 13.4951 15.738 13.4831C15.716 13.4831 15.666 13.4441 15.666 13.3661C15.688 13.3191 15.709 13.2491 15.727 13.1711L15.747 13.1081C15.751 13.0921 15.769 13.0811 15.786 13.0881C15.806 13.0881 15.815 13.1081 15.811 13.1231L15.794 13.1891C15.773 13.2711 15.755 13.3411 15.731 13.3841C15.735 13.3961 15.747 13.4111 15.751 13.4111C15.773 13.4191 15.79 13.4271 15.802 13.4311C15.806 13.4111 15.812 13.3961 15.816 13.3801C15.824 13.3331 15.833 13.3061 15.853 13.2981C15.859 13.3061 15.867 13.3211 15.878 13.3411L15.892 13.3451C15.892 13.3491 15.892 13.3611 15.888 13.3721C15.888 13.3761 15.888 13.3801 15.888 13.3841C15.88 13.4111 15.878 13.4351 15.87 13.4471C15.874 13.4511 15.884 13.4591 15.913 13.4671C15.934 13.4751 15.954 13.4791 15.964 13.4751C15.98 13.4671 15.989 13.4401 15.997 13.3891L16.009 13.3971L15.976 13.3541C15.982 13.3421 16.009 13.3341 16.027 13.3381C16.041 13.3421 16.066 13.3851 16.066 13.3971C16.056 13.4601 16.037 13.5101 15.998 13.5341C15.98 13.5461 15.967 13.5461 15.953 13.5461Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_32"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask31_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M15.7502 13.4841C15.7502 13.4841 15.7462 13.4841 15.7422 13.4841C15.6622 13.4611 15.6152 13.4181 15.6152 13.3711C15.6152 13.3441 15.6362 13.3051 15.7202 13.2891C15.7382 13.2891 15.7572 13.2971 15.7632 13.3161C15.7632 13.3361 15.7533 13.3471 15.7343 13.3511C15.6913 13.3591 15.6833 13.3741 15.6833 13.3741C15.6833 13.3781 15.7082 13.4011 15.7592 13.4131C15.7752 13.4211 15.7843 13.4401 15.7812 13.4561C15.7773 13.4731 15.7682 13.4841 15.7502 13.4841Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_33"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask32_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M16.4883 13.6948C16.4743 13.6948 16.4493 13.6828 16.4413 13.6748C16.4373 13.6868 16.3822 13.6708 16.3822 13.5768C16.3722 13.5768 16.3433 13.5688 16.3253 13.5568C16.2603 13.5838 16.1863 13.5918 16.1393 13.5728C16.1213 13.5998 16.1003 13.6198 16.0753 13.6318C16.0533 13.6398 16.0343 13.6318 16.0283 13.6158C16.0163 13.5998 16.0282 13.5768 16.0462 13.5688C16.0642 13.5608 16.0792 13.5488 16.0892 13.5338C16.0792 13.5178 16.0753 13.4988 16.0753 13.4788C16.0673 13.4628 16.0593 13.4278 16.0753 13.4048C16.1323 13.3968 16.1553 13.4168 16.1693 13.4638C16.1693 13.4838 16.1693 13.4988 16.1653 13.5108C16.1873 13.5188 16.2243 13.5188 16.2673 13.5068C16.2383 13.4718 16.2342 13.4248 16.2532 13.3938C16.2742 13.3468 16.3253 13.3238 16.3763 13.3428C16.4193 13.3588 16.4403 13.3978 16.4363 13.4408C16.4363 13.4758 16.4223 13.5068 16.3933 13.5268C16.4093 13.5348 16.4183 13.5468 16.4323 13.5498C16.4523 13.6158 16.4593 13.6158 16.4693 13.6158C16.4833 13.6158 16.5103 13.5728 16.5103 13.5258V13.2988C16.5103 13.2598 16.5783 13.2598 16.5783 13.2988V13.5258C16.5783 13.5888 16.5412 13.6708 16.4982 13.6898C16.4962 13.6908 16.4923 13.6948 16.4883 13.6948Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_34"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask33_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M16.6229 13.6127C16.6059 13.6127 16.5859 13.5967 16.5859 13.5777C16.5859 13.5427 16.5939 13.4837 16.6059 13.4297C16.6139 13.3787 16.6159 13.3357 16.6159 13.3007C16.6159 13.2617 16.6839 13.2617 16.6839 13.3007C16.6839 13.3397 16.678 13.3867 16.67 13.4417C16.664 13.4927 16.6559 13.5467 16.6559 13.5787C16.6559 13.5977 16.6409 13.6127 16.6229 13.6127Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_35"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask34_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M16.6994 13.7659C16.6914 13.7659 16.6814 13.7619 16.6744 13.7539C16.6604 13.7379 16.6644 13.7149 16.6824 13.7029C16.7334 13.6639 16.7544 13.6369 16.7624 13.6049C16.7464 13.5969 16.7354 13.5819 16.7254 13.5739C16.7074 13.5429 16.7074 13.5109 16.7174 13.4959C16.7254 13.4839 16.7544 13.4729 16.7684 13.4729C16.7934 13.4729 16.8194 13.4999 16.8344 13.5429C16.8344 13.5509 16.8364 13.5589 16.8344 13.5659C16.8404 13.5659 16.8484 13.5659 16.8554 13.5659C16.8554 13.5659 16.8654 13.5579 16.8654 13.5189C16.8554 13.5069 16.8474 13.4989 16.8474 13.4799C16.8474 13.4569 16.8724 13.4209 16.8904 13.4209C16.9104 13.4209 16.9274 13.4479 16.9354 13.4639C16.9454 13.4639 16.9604 13.4639 16.9824 13.4639C17.0394 13.4949 17.1404 13.4909 17.1644 13.4759C17.2254 13.4639 17.2464 13.5069 17.2464 13.5779C17.2464 13.5819 17.2324 13.6289 17.2284 13.6329C17.2104 13.6799 17.1954 13.7109 17.1644 13.7189C17.1314 13.7229 17.1014 13.7029 17.0844 13.6799C17.0724 13.6449 17.0724 13.6369 17.0334 13.6369H16.8554C16.8434 13.6369 16.8344 13.6369 16.8264 13.6329C16.8124 13.6719 16.7834 13.7109 16.7214 13.7579C16.7174 13.7619 16.7114 13.7659 16.6994 13.7659ZM16.9284 13.5659H17.0334C17.1274 13.5659 17.1404 13.6209 17.1404 13.6519L17.1694 13.6009C17.1734 13.5739 17.1774 13.5579 17.1734 13.5459C17.1134 13.5619 17.0114 13.5539 16.9664 13.5299C16.9604 13.5299 16.9454 13.5339 16.9354 13.5339C16.9354 13.5469 16.9324 13.5589 16.9284 13.5659Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_36"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask35_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M17.3166 13.6365C17.3046 13.6365 17.3006 13.6325 17.2966 13.6285C17.2716 13.6245 17.2576 13.6285 17.2456 13.6325C17.2246 13.6325 17.1946 13.6165 17.1946 13.6015C17.1946 13.5815 17.1906 13.5665 17.2146 13.5665V13.6015L17.2326 13.5625C17.2426 13.5625 17.2546 13.5585 17.2696 13.5585C17.2696 13.5235 17.2836 13.4995 17.2926 13.4925C17.3156 13.4655 17.3476 13.4615 17.3766 13.4725C17.4096 13.4885 17.4276 13.5195 17.4276 13.5505C17.4286 13.6015 17.3526 13.6365 17.3166 13.6365Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_37"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask36_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M17.5219 13.6284C17.5119 13.6284 17.4999 13.6284 17.4929 13.6244C17.4789 13.6204 17.4619 13.5934 17.4619 13.5774C17.4909 13.5344 17.5229 13.5144 17.5519 13.5074C17.5599 13.4524 17.5559 13.3744 17.5379 13.3084C17.5299 13.2924 17.5419 13.2694 17.5589 13.2654C17.5809 13.2614 17.5979 13.2734 17.6019 13.2924C17.6219 13.3554 17.6309 13.4524 17.6219 13.5264C17.6279 13.5264 17.6729 13.5464 17.6749 13.5464C17.6999 13.5464 17.7119 13.5344 17.7159 13.4874C17.6959 13.4644 17.6789 13.4324 17.6869 13.4214C17.6929 13.4054 17.7239 13.3944 17.7419 13.3984C17.7559 13.3984 17.7849 13.4334 17.7849 13.4494C17.7849 13.4574 17.7809 13.4654 17.7809 13.4724C17.7849 13.4764 17.7849 13.4804 17.7809 13.4844C17.7769 13.5824 17.7519 13.6134 17.6759 13.6134C17.6409 13.6294 17.6119 13.6214 17.5939 13.6094C17.5939 13.6054 17.5899 13.6054 17.5899 13.6014C17.5659 13.6204 17.5409 13.6284 17.5219 13.6284Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_38"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask37_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M17.826 13.7148C17.82 13.7148 17.808 13.7108 17.804 13.7028C17.79 13.6948 17.79 13.6678 17.804 13.6558C17.826 13.6328 17.847 13.6008 17.859 13.5658C17.8 13.5388 17.791 13.4998 17.791 13.4798C17.791 13.4638 17.791 13.4168 17.826 13.4018C17.863 13.3938 17.894 13.4218 17.924 13.4528C17.965 13.5308 17.91 13.6478 17.852 13.7028C17.844 13.7108 17.838 13.7148 17.826 13.7148Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_39"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask38_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M18.0077 13.6637C17.9937 13.6637 17.9787 13.6517 17.9747 13.6437C17.9687 13.6237 17.9747 13.6007 17.9947 13.5967C18.0197 13.5887 18.0337 13.5737 18.0417 13.5617C17.9867 13.5617 17.9657 13.5417 17.9617 13.5147C17.9537 13.4797 17.9737 13.4447 18.0127 13.4167C18.0247 13.4127 18.0637 13.4007 18.0717 13.4047C18.0987 13.4167 18.1147 13.4477 18.1187 13.4947C18.2087 13.4787 18.3357 13.4477 18.4237 13.3927C18.4377 13.3807 18.4627 13.3847 18.4707 13.4007C18.4807 13.4207 18.4787 13.4397 18.4587 13.4477C18.3497 13.5177 18.2127 13.5497 18.1147 13.5567C18.1027 13.5957 18.0857 13.6347 18.0207 13.6587C18.0157 13.6637 18.0117 13.6637 18.0077 13.6637Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_40"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask39_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M18.3133 13.5654C18.3013 13.5654 18.2883 13.5614 18.2783 13.5574C18.2553 13.5304 18.2413 13.4984 18.2293 13.4594C18.2233 13.4754 18.2233 13.4904 18.2233 13.4984C18.2233 13.5414 18.1533 13.5414 18.1533 13.4984C18.1533 13.4474 18.1763 13.3964 18.2083 13.3774C18.2043 13.3734 18.2043 13.3614 18.2043 13.3544L18.1793 13.2564C18.1773 13.2404 18.1833 13.2174 18.2003 13.2134C18.2233 13.2054 18.2413 13.2174 18.2453 13.2404L18.2703 13.3424C18.2703 13.3464 18.2743 13.3464 18.2743 13.3504C18.2883 13.3464 18.3093 13.3504 18.3353 13.3584C18.3723 13.3784 18.3993 13.4094 18.3993 13.4484C18.4113 13.4684 18.4073 13.5114 18.3813 13.5424C18.3633 13.5584 18.3383 13.5654 18.3133 13.5654Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_41"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask40_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M18.5039 13.4993C18.4569 13.4993 18.422 13.4723 18.406 13.4333C18.402 13.4253 18.406 13.3823 18.41 13.3743C18.449 13.3083 18.57 13.3003 18.617 13.3473C18.635 13.3903 18.629 13.4133 18.613 13.4453C18.592 13.4723 18.5449 13.4993 18.5039 13.4993Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_42"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask41_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M18.7195 13.4054C18.6995 13.4054 18.6865 13.4014 18.6765 13.3974C18.6175 13.3664 18.5886 13.2924 18.5886 13.1674C18.5886 13.1444 18.5805 13.1244 18.5635 13.1244C18.5415 13.1124 18.5125 13.1243 18.4955 13.1403C18.4795 13.1523 18.4585 13.1523 18.4445 13.1403C18.4325 13.1283 18.4325 13.1053 18.4445 13.0973C18.4835 13.0543 18.5466 13.0383 18.5926 13.0583C18.6316 13.0783 18.6536 13.1174 18.6536 13.1674C18.6536 13.2764 18.6826 13.3273 18.7086 13.3433C18.7206 13.3433 18.7315 13.3433 18.7415 13.3433C18.7415 13.3433 18.7415 13.3393 18.7455 13.3353C18.7515 13.3193 18.7885 13.2804 18.8065 13.2884C18.8225 13.2924 18.8355 13.3353 18.8355 13.3473C18.7835 13.3973 18.7445 13.4054 18.7195 13.4054Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_43"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask42_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M17.1603 10.9258L19.3633 12.9648L19.2073 9.25377C19.1843 8.69077 18.6933 8.81576 18.3383 9.01976C17.9793 9.25376 17.5703 9.25376 17.1353 9.10176C16.6993 9.25376 16.2893 9.25376 15.9303 9.01976C15.5773 8.81676 15.0863 8.69177 15.0653 9.25377L14.9053 12.9648L17.1603 10.9258Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_44"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask43_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M14.9041 12.9955C14.9001 12.9955 14.8941 12.9955 14.8901 12.9955C14.8781 12.9915 14.8701 12.9755 14.8701 12.9605L15.0261 9.24951C15.0421 8.89051 15.2411 8.81152 15.4031 8.81152C15.6061 8.81152 15.8311 8.92452 15.9481 8.98752C16.2741 9.19852 16.6691 9.22152 17.1221 9.06552C17.6301 9.22152 17.9931 9.19852 18.3191 8.98752C18.4341 8.92452 18.6631 8.81152 18.8581 8.81152C19.0261 8.81152 19.2251 8.88951 19.2391 9.24951L19.3951 12.9605C19.3951 12.9765 19.3871 12.9915 19.3771 12.9955C19.3651 12.9995 19.3481 12.9995 19.3361 12.9915L17.1581 10.9685L14.9241 12.9915C14.9221 12.9955 14.9161 12.9955 14.9041 12.9955ZM15.4041 8.88251C15.2091 8.88251 15.1071 9.00351 15.0971 9.25351L14.9451 12.8865L17.1361 10.8985C17.1481 10.8825 17.1691 10.8825 17.1851 10.8985L19.3281 12.8865L19.1721 9.25351C19.1561 8.83151 18.8281 8.78051 18.3561 9.05051C18.0161 9.26951 17.5981 9.30051 17.1231 9.13251C16.6991 9.30051 16.2581 9.26951 15.9121 9.05051C15.7251 8.94451 15.5431 8.88251 15.4041 8.88251Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_45"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask44_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M17.4924 9.22624C17.6214 9.30424 17.7464 9.30424 17.8264 9.30424C17.5704 9.12024 17.4924 8.63624 17.5194 8.43324C17.5704 8.02324 17.4684 7.79626 17.2144 7.74226C17.1634 7.74226 17.1344 7.71525 17.0324 7.71525C16.9564 7.69225 16.8934 7.76624 16.8644 7.81724C16.7884 7.76624 16.7234 7.79724 16.6474 7.74324C16.5714 7.71624 16.4404 7.74326 16.4404 7.92326L16.4914 7.90324C16.5164 7.90724 16.5574 7.93027 16.6124 7.95827C16.6764 8.00927 16.7704 8.05225 16.8004 8.22825C16.8554 8.61525 16.8004 8.96626 16.4414 9.30626C16.5214 9.30626 16.6484 9.30625 16.7714 9.22825C16.7244 9.30625 16.6994 9.33026 16.6484 9.38426C16.8004 9.35726 16.9314 9.30626 17.0034 9.17726C17.0324 9.22826 17.1054 9.30625 17.1344 9.35725C17.1634 9.30625 17.2364 9.22826 17.2654 9.17726C17.3374 9.30626 17.4684 9.35726 17.6204 9.38426C17.5704 9.32726 17.5434 9.30424 17.4924 9.22624Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_46"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask45_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M16.5554 9.42981L16.6274 9.3598C16.6444 9.3398 16.6604 9.32081 16.6784 9.30881C16.5864 9.33581 16.5004 9.33582 16.4424 9.33582H16.3604L16.4244 9.27682C16.7254 8.99582 16.8344 8.68283 16.7684 8.22983C16.7504 8.09283 16.6884 8.05381 16.6274 8.00681L16.5904 7.98383C16.5394 7.95683 16.5044 7.93283 16.4884 7.93283L16.4124 7.9678V7.92081C16.4124 7.71381 16.5624 7.67481 16.6604 7.70981C16.6994 7.73681 16.7284 7.74081 16.7624 7.74881C16.7894 7.75281 16.8234 7.75682 16.8604 7.77182C16.8854 7.73282 16.9364 7.67383 17.0054 7.67383C17.0954 7.68183 17.1364 7.68981 17.1654 7.70081C17.1834 7.70481 17.1964 7.7048 17.2164 7.7048C17.4934 7.7638 17.6034 8.00581 17.5484 8.43881C17.5264 8.64581 17.6074 9.10681 17.8454 9.27081L17.9334 9.33383H17.8284C17.7714 9.33383 17.6874 9.33382 17.5964 9.30682C17.6084 9.31882 17.6254 9.33782 17.6434 9.36182L17.7174 9.4248L17.6154 9.41281C17.4984 9.39281 17.3574 9.34982 17.2674 9.23282C17.2554 9.24882 17.2404 9.26381 17.2264 9.28381C17.2014 9.31481 17.1794 9.34281 17.1654 9.36581L17.1364 9.41681L17.1074 9.36581C17.0954 9.34281 17.0704 9.31481 17.0484 9.28381C17.0344 9.26381 17.0194 9.24882 17.0054 9.23282C16.9154 9.34982 16.7734 9.39281 16.6574 9.41281L16.5554 9.42981ZM17.2624 9.11682L17.2934 9.16382C17.3384 9.23782 17.4144 9.29282 17.5254 9.32382C17.5114 9.30382 17.4924 9.28082 17.4684 9.24582L17.5114 9.19882C17.5874 9.24582 17.6714 9.26183 17.7404 9.26483C17.5214 9.04583 17.4654 8.61983 17.4864 8.43283C17.5334 8.03483 17.4414 7.81983 17.2074 7.77283C17.1874 7.78483 17.1684 7.7688 17.1444 7.7608C17.1174 7.7528 17.0844 7.74881 17.0254 7.74881C16.9454 7.74881 16.9064 7.81181 16.8944 7.83081L16.8804 7.86182L16.8514 7.84583C16.8184 7.81883 16.7854 7.81482 16.7534 7.81082C16.7164 7.80282 16.6734 7.79882 16.6324 7.76782C16.6124 7.76382 16.5034 7.73281 16.4784 7.86981C16.5254 7.86981 16.5584 7.89281 16.6054 7.91681L16.6604 7.95581C16.7284 8.00281 16.8084 8.0578 16.8344 8.2218C16.8734 8.5188 16.8694 8.90983 16.5214 9.26483C16.5934 9.26483 16.6774 9.24482 16.7574 9.19882L16.8004 9.24582C16.7784 9.28082 16.7614 9.30482 16.7414 9.32382C16.8584 9.29282 16.9304 9.23782 16.9774 9.16382L17.0064 9.11682L17.0314 9.16382C17.0454 9.18382 17.0664 9.21482 17.0924 9.24582C17.1084 9.26182 17.1214 9.27681 17.1334 9.29681C17.1474 9.27681 17.1584 9.26182 17.1724 9.24582C17.1944 9.21482 17.2194 9.18282 17.2354 9.16382L17.2624 9.11682Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_47"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask46_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M17.5121 9.28418C17.5001 9.28418 17.4871 9.2762 17.4791 9.2642C17.4071 9.1192 17.3311 8.95919 17.3311 8.73719C17.3311 8.70219 17.399 8.70219 17.399 8.73719C17.399 8.94419 17.4651 9.08919 17.5421 9.23319C17.5481 9.25319 17.5421 9.26819 17.5261 9.28019C17.5221 9.28419 17.5201 9.28418 17.5121 9.28418Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_48"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask47_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M17.2663 9.21018C17.2543 9.21018 17.2433 9.20619 17.2373 9.19419C17.1823 9.11219 17.1533 8.95619 17.1533 8.73719C17.1533 8.70219 17.2213 8.70219 17.2213 8.73719C17.2213 8.93619 17.2463 9.08518 17.2933 9.15918C17.3053 9.17518 17.2973 9.19418 17.2833 9.20618C17.2753 9.21018 17.2723 9.21018 17.2663 9.21018Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_49"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask48_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M16.7581 9.28418C16.7541 9.28418 16.7461 9.28419 16.7421 9.28019C16.7241 9.26819 16.7211 9.25319 16.7281 9.23319C16.8001 9.09619 16.8691 8.94419 16.8691 8.73719C16.8691 8.70219 16.9371 8.70219 16.9371 8.73719C16.9371 8.96019 16.8651 9.1202 16.7891 9.2642C16.7831 9.2762 16.7721 9.28418 16.7581 9.28418Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_50"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask49_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M17.0037 9.21018C16.9997 9.21018 16.9917 9.21018 16.9857 9.20618C16.9697 9.19418 16.9657 9.17518 16.9737 9.15918C17.0207 9.08518 17.0497 8.93619 17.0497 8.73719C17.0497 8.70219 17.1157 8.70219 17.1157 8.73719C17.1157 8.95619 17.0867 9.11219 17.0357 9.19419C17.0287 9.20619 17.0157 9.21018 17.0037 9.21018Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_51"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask50_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M16.4609 7.8979C16.5139 7.9019 16.5349 7.92089 16.6129 7.95689C16.6599 7.98389 16.7709 8.05089 16.8009 8.20689C16.7719 8.12489 16.826 8.05089 16.881 8.07789C16.801 7.89489 16.5629 7.8519 16.4609 7.8979Z",
    fill: "#F0C727"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_52"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask51_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M16.8011 8.21826C16.7971 8.21826 16.7891 8.21427 16.7851 8.21027C16.7851 8.21027 16.7851 8.21027 16.7851 8.20627C16.7831 8.20227 16.7791 8.18326 16.7791 8.17526C16.7461 8.05426 16.6481 7.99926 16.6051 7.97226L16.576 7.94125L16.5641 7.95328C16.5211 7.93028 16.4991 7.91428 16.4561 7.91428C16.4771 7.86728 16.513 7.86328 16.554 7.86328C16.677 7.86328 16.8331 7.92628 16.8941 8.07028C16.8981 8.07428 16.8841 8.07828 16.8801 8.08228C16.8801 8.08228 16.8641 8.08228 16.8591 8.08228C16.8141 8.11328 16.8081 8.14127 16.8121 8.16827C16.8121 8.17227 16.8121 8.17627 16.8081 8.18027C16.8141 8.18827 16.8141 8.20028 16.8181 8.20328C16.8181 8.21128 16.814 8.21927 16.804 8.21927H16.8011V8.21826ZM16.5141 7.89728C16.5351 7.90128 16.5551 7.90526 16.5841 7.92026L16.619 7.94327C16.66 7.96627 16.7381 8.00927 16.7851 8.10727C16.7931 8.09527 16.8011 8.08026 16.8081 8.08026C16.8221 8.06026 16.8391 8.05325 16.8591 8.05325C16.8051 7.94025 16.6231 7.87828 16.5141 7.89728Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_53"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask52_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M17.2366 11.332L17.5436 12.734L17.4416 12.84L17.3386 12.758L17.1646 11.504L17.2366 12.758L17.1356 12.891L17.0336 12.758L17.1056 11.504L16.9326 12.758L16.8266 12.84L16.7256 12.734L17.0336 11.332H17.2366Z",
    fill: "#F0C727"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_54"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask53_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M17.1351 12.9338L17.0121 12.7779L17.0431 12.1758L16.9611 12.7618L16.8441 12.8598L16.7031 12.7549L17.0041 11.3249L17.2361 11.2979L17.5721 12.7278L17.4651 12.8608L17.3191 12.7828L17.2291 12.1658L17.2661 12.7599L17.1351 12.9338ZM17.1351 11.5269L17.0631 12.7568L17.1351 12.8428L17.2151 12.7408L17.1351 11.5269ZM17.2071 11.3358L17.0331 11.3589L16.7541 12.7419L16.8481 12.8159L16.9141 12.7339L17.0801 11.4998L17.1351 11.5038L17.1881 11.4998L17.3681 12.7538L17.4621 12.8128L17.5261 12.7108L17.2071 11.3358Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_55"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask54_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M15.3183 9.12012L15.1663 12.7331L14.9043 12.9631L15.0643 9.25211C15.1373 9.19811 15.2643 9.12012 15.3183 9.12012Z",
    fill: "#F0C727"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_56"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask55_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M15.6253 9.38275L15.4963 12.4028L15.2383 12.6688L15.3943 9.17676C15.4453 9.22676 15.5983 9.35475 15.6253 9.38275Z",
    fill: "#F0C727"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_57"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask56_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M15.9057 9.61295L15.8037 12.1329L15.5967 12.3359L15.7257 9.46094C15.7747 9.51194 15.8767 9.58595 15.9057 9.61295Z",
    fill: "#F0C727"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_58"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask57_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M16.2112 9.74207L16.1093 11.8871L15.9062 12.0511L16.0082 9.66406C16.0602 9.68406 16.1622 9.74207 16.2112 9.74207Z",
    fill: "#F0C727"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_59"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask58_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M16.4919 9.74121L16.42 11.5342L16.2109 11.7332L16.2889 9.76422C16.3399 9.76522 16.4709 9.76521 16.4919 9.74121Z",
    fill: "#F0C727"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_60"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask59_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M18.9512 9.12012L19.1052 12.7331L19.3632 12.9631L19.2072 9.25211C19.1352 9.19811 19.0042 9.12012 18.9512 9.12012Z",
    fill: "#F0C727"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_61"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask60_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M18.6436 9.38278L18.7745 12.4028L19.0326 12.6328L18.8766 9.17578C18.8246 9.22678 18.6726 9.35478 18.6436 9.38278Z",
    fill: "#F0C727"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_62"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask61_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    d: "M18.3633 9.61295L18.4683 12.1329L18.6713 12.2929L18.5403 9.46094C18.4903 9.51194 18.3893 9.58595 18.3633 9.61295Z",
    fill: "#F0C727"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_63"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask62_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    d: "M18.0596 9.74112L18.1616 11.8461L18.3646 12.0141L18.2626 9.66211C18.2116 9.68311 18.1096 9.74112 18.0596 9.74112Z",
    fill: "#F0C727"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_64"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask63_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M17.7754 9.74121L17.8514 11.5342L18.0584 11.7332L17.9784 9.76422C17.9284 9.76522 17.7974 9.76521 17.7754 9.74121Z",
    fill: "#F0C727"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_65"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask64_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M16.4411 10.7148L15.8281 12.8908L16.6741 13.0158L17.0331 11.3788L16.4411 10.7148Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_66"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask65_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    d: "M16.6739 13.0467C16.6699 13.0467 16.6699 13.0467 16.6699 13.0467L15.8259 12.9177C15.8139 12.9137 15.8059 12.9097 15.8009 12.9017C15.7969 12.8937 15.7969 12.8897 15.7969 12.8817L16.4119 10.7017C16.4159 10.6857 16.4239 10.6787 16.4329 10.6787C16.4449 10.6787 16.4559 10.6787 16.4659 10.6867L17.0579 11.3587L16.7059 13.0227C16.6989 13.0387 16.6879 13.0467 16.6739 13.0467ZM15.8689 12.8587L16.6439 12.9797L16.9989 11.3707L16.4559 10.7727L15.8689 12.8587Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_67"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask66_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    d: "M17.8263 10.7148L18.4403 12.8908L17.5943 13.0158L17.2363 11.3788L17.8263 10.7148Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_68"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask67_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M17.5941 13.0467C17.5801 13.0467 17.5711 13.0387 17.5671 13.0237L17.2041 11.3827L17.8061 10.6877C17.8141 10.6797 17.8241 10.6797 17.8351 10.6797C17.8451 10.6797 17.8531 10.6917 17.8561 10.7027L18.4731 12.8827C18.4731 12.8907 18.4731 12.8947 18.4691 12.9027C18.4611 12.9107 18.4531 12.9147 18.4441 12.9187L17.6021 13.0477C17.6021 13.0477 17.5981 13.0467 17.5941 13.0467ZM17.8131 10.7767L17.2621 11.3977L17.6211 12.9797L18.3981 12.8587L17.8131 10.7767Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_69"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask68_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    d: "M16.3154 11.6638C16.3114 11.6638 16.3114 11.6638 16.3094 11.6638C16.2974 11.6638 16.2865 11.6558 16.2825 11.6408L16.2084 11.4648C16.2044 11.4448 16.2085 11.4298 16.2265 11.4218C16.2445 11.4098 16.2655 11.4218 16.2735 11.4378L16.3284 11.5708L16.5235 11.3558C16.5355 11.3397 16.5524 11.3397 16.5664 11.3558C16.5824 11.3678 16.5864 11.3827 16.5704 11.3987L16.3385 11.6568C16.3305 11.6598 16.3224 11.6638 16.3154 11.6638Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_70"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask69_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    d: "M16.5984 11.8158C16.5984 11.8158 16.5944 11.8158 16.5904 11.8158C16.5764 11.8118 16.5654 11.8038 16.5654 11.7888L16.4854 11.0738C16.4854 11.0538 16.5014 11.0348 16.5184 11.0348C16.5364 11.0308 16.5514 11.0468 16.5554 11.0658L16.6234 11.6948L16.8264 11.4328C16.8364 11.4168 16.8594 11.4128 16.8734 11.4248C16.8874 11.4328 16.8914 11.4558 16.8814 11.4718L16.6274 11.8078C16.6194 11.8128 16.6134 11.8158 16.5984 11.8158Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_71"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask70_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    d: "M16.902 11.9999C16.89 11.9999 16.877 11.988 16.869 11.98L16.721 11.5889C16.715 11.5809 16.721 11.5579 16.739 11.5499C16.755 11.5419 16.776 11.55 16.784 11.57L16.936 11.949C16.942 11.969 16.936 11.988 16.916 11.996C16.914 12 16.91 11.9999 16.902 11.9999Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_72"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask71_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    d: "M16.6738 12.3043C16.6698 12.3043 16.6657 12.3043 16.6637 12.3043C16.6517 12.3003 16.6437 12.2923 16.6407 12.2843L16.5358 11.9483L16.4498 12.1083C16.4418 12.1203 16.4287 12.1353 16.4207 12.1283C16.4067 12.1283 16.3957 12.1163 16.3877 12.1053L16.3017 11.8943L16.1107 12.0663C16.0987 12.0823 16.0778 12.0823 16.0618 12.0663C16.0518 12.0503 16.0517 12.0273 16.0657 12.0193L16.2907 11.8123C16.3027 11.8083 16.3117 11.8043 16.3197 11.8083C16.3317 11.8083 16.3407 11.8163 16.3447 11.8283L16.4247 12.0163L16.5148 11.8443C16.5228 11.8363 16.5357 11.8323 16.5477 11.8323C16.5637 11.8323 16.5727 11.8363 16.5767 11.8523L16.6877 12.2113L16.8597 12.0393C16.8697 12.0273 16.8908 12.0273 16.9068 12.0393C16.9168 12.0513 16.9168 12.0783 16.9068 12.0903L16.6958 12.2973C16.6908 12.3003 16.6818 12.3043 16.6738 12.3043Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_73"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask72_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_142",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_143",
    d: "M16.7542 12.7692C16.7342 12.7692 16.7212 12.7572 16.7172 12.7422L16.6532 12.4292L16.4972 12.6282C16.4892 12.6402 16.4792 12.6442 16.4642 12.6402C16.4542 12.6402 16.4432 12.6282 16.4392 12.6172L16.3572 12.3672L16.2142 12.5472C16.2082 12.5592 16.2002 12.5592 16.1852 12.5632C16.1752 12.5592 16.1642 12.5512 16.1582 12.5402L16.0002 12.1552C15.9922 12.1392 16.0002 12.1202 16.0182 12.1122C16.0362 12.1002 16.0552 12.1122 16.0612 12.1322L16.2002 12.4602L16.3452 12.2722C16.3492 12.2642 16.3622 12.2602 16.3742 12.2602C16.3882 12.2642 16.3992 12.2722 16.4032 12.2832L16.4832 12.5332L16.6452 12.3222C16.6572 12.3142 16.6662 12.3062 16.6822 12.3102C16.6922 12.3142 16.7032 12.3262 16.7072 12.3372L16.7832 12.7242C16.7892 12.7442 16.7752 12.7592 16.7582 12.7672C16.7542 12.7692 16.7542 12.7692 16.7542 12.7692Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_74"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask73_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_144",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_145",
    d: "M16.5431 13.0508C16.5391 13.0508 16.5351 13.0468 16.5351 13.0468C16.5251 13.0468 16.5141 13.0388 16.5141 13.0268L16.4321 12.7888L16.3191 12.9838C16.3151 12.9958 16.3011 13.0038 16.2861 12.9958C16.2761 12.9958 16.2651 12.9918 16.2591 12.9758L16.1541 12.6948L16.0371 12.8588C16.0271 12.8748 16.0061 12.8748 15.9901 12.8668C15.9761 12.8508 15.9721 12.8358 15.9821 12.8158L16.1341 12.6088C16.1421 12.5968 16.1571 12.5928 16.1671 12.5928C16.1791 12.5928 16.1891 12.6048 16.1921 12.6158L16.2971 12.8888L16.4121 12.6898C16.4201 12.6778 16.4321 12.6738 16.4451 12.6738C16.4611 12.6738 16.4701 12.6858 16.4741 12.6938L16.5621 12.9558L16.6771 12.8578C16.6911 12.8458 16.7161 12.8498 16.7281 12.8658C16.7381 12.8818 16.7381 12.9008 16.7241 12.9088L16.5641 13.0418C16.5591 13.0468 16.5511 13.0508 16.5431 13.0508Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_75"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask74_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_146",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_147",
    d: "M17.9574 11.6638C17.9454 11.6638 17.9354 11.6598 17.9324 11.6558L17.7004 11.3978C17.6904 11.3818 17.6904 11.3668 17.7044 11.3548C17.7164 11.3388 17.7414 11.3388 17.7514 11.3548L17.9464 11.5698L17.9974 11.4368C18.0054 11.4208 18.0264 11.4098 18.0464 11.4208C18.0604 11.4288 18.0714 11.4438 18.0644 11.4638L17.9884 11.6398C17.9844 11.6558 17.9744 11.6628 17.9634 11.6628C17.9614 11.6638 17.9614 11.6638 17.9574 11.6638Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_76"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask75_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_148",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_149",
    d: "M17.674 11.8158C17.664 11.8158 17.6529 11.8118 17.6449 11.8078L17.3889 11.4718C17.3769 11.4558 17.3809 11.4328 17.3949 11.4248C17.4109 11.4128 17.4319 11.4128 17.4419 11.4328L17.6489 11.6948L17.7149 11.0658C17.7149 11.0458 17.7329 11.0308 17.7499 11.0348C17.7699 11.0348 17.7829 11.0548 17.7789 11.0738L17.7109 11.7888C17.7069 11.8008 17.6949 11.8118 17.6859 11.8158C17.6819 11.8158 17.678 11.8158 17.674 11.8158Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_77"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask76_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_150",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_151",
    d: "M17.3667 11.9995C17.3627 11.9995 17.3548 11.9995 17.3508 11.9955C17.3328 11.9875 17.3258 11.9685 17.3328 11.9485L17.4847 11.5695C17.4907 11.5495 17.5098 11.5425 17.5278 11.5495C17.5458 11.5575 17.5527 11.5805 17.5457 11.5885L17.3978 11.9795C17.3908 11.9875 17.3807 11.9995 17.3667 11.9995Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_78"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask77_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    d: "M17.5939 12.3043C17.5879 12.3043 17.5759 12.3003 17.5719 12.2963L17.3689 12.0893C17.3549 12.0733 17.3549 12.0503 17.3689 12.0383C17.3809 12.0263 17.4019 12.0263 17.4179 12.0383L17.5759 12.2063L17.6639 11.8513C17.6679 11.8393 17.6779 11.8313 17.6909 11.8313C17.7069 11.8273 17.7179 11.8313 17.7239 11.8433L17.8429 12.0233L17.9229 11.8283C17.9269 11.8163 17.9389 11.8083 17.9449 11.8083C17.9609 11.8043 17.9679 11.8083 17.9779 11.8123L18.2069 12.0193C18.2229 12.0273 18.2269 12.0463 18.2109 12.0663C18.1989 12.0823 18.1779 12.0823 18.1639 12.0663L17.9689 11.8943L17.8809 12.1053C17.8769 12.1173 17.8669 12.1283 17.8519 12.1283C17.8419 12.1283 17.8309 12.1243 17.8229 12.1123L17.7159 11.9443L17.6319 12.2803C17.6279 12.2923 17.6219 12.3003 17.6069 12.3033C17.6019 12.3043 17.6019 12.3043 17.5939 12.3043Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_79"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask78_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask78_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    d: "M17.5202 12.7697C17.5162 12.7697 17.5163 12.7697 17.5123 12.7697C17.4923 12.7617 17.4833 12.7467 17.4873 12.7267L17.5632 12.3397C17.5672 12.3277 17.5733 12.3167 17.5883 12.3127C17.6023 12.3087 17.6172 12.3167 17.6232 12.3287L17.7872 12.5357L17.8673 12.2857C17.8713 12.2737 17.8813 12.2657 17.8943 12.2627C17.9063 12.2627 17.9213 12.2667 17.9273 12.2747L18.0703 12.4627L18.2033 12.1347C18.2113 12.1147 18.2323 12.1037 18.2503 12.1147C18.2703 12.1227 18.2772 12.1417 18.2702 12.1577L18.1143 12.5407C18.1103 12.5527 18.0982 12.5607 18.0892 12.5637C18.0752 12.5637 18.0643 12.5597 18.0563 12.5477L17.9153 12.3677L17.8313 12.6177C17.8273 12.6297 17.8173 12.6407 17.8063 12.6407C17.7943 12.6447 17.7813 12.6407 17.7753 12.6287L17.6192 12.4297L17.5533 12.7427C17.5473 12.7577 17.5332 12.7697 17.5202 12.7697Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_80"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask79_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_156",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask79_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_157",
    d: "M17.7256 13.0508C17.7196 13.0508 17.7116 13.0468 17.7036 13.0428L17.5476 12.9098C17.5296 12.9018 17.5296 12.8828 17.5416 12.8668C17.5556 12.8508 17.5766 12.8468 17.5926 12.8588L17.7116 12.9568L17.7936 12.6948C17.7976 12.6868 17.8096 12.6747 17.8226 12.6747C17.8346 12.6747 17.8516 12.6788 17.8556 12.6908L17.9726 12.8898L18.0766 12.6168C18.0806 12.6048 18.0926 12.5938 18.1016 12.5938C18.1136 12.5938 18.1266 12.5977 18.1346 12.6097L18.2866 12.8167C18.2966 12.8367 18.2946 12.8518 18.2786 12.8678C18.2646 12.8758 18.2436 12.8757 18.2316 12.8597L18.1166 12.6958L18.0116 12.9767C18.0076 12.9927 17.9956 12.9968 17.9826 12.9968C17.9686 13.0048 17.9576 12.9967 17.9496 12.9847L17.8386 12.7938L17.7586 13.0278C17.7546 13.0398 17.7426 13.0478 17.7366 13.0478C17.7326 13.0468 17.7286 13.0508 17.7256 13.0508Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_81"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask80_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_158",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask80_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_159",
    d: "M17.1351 9.46094C17.3911 9.66394 17.7251 9.76594 18.1101 9.74194C18.0811 10.6369 17.8271 11.2499 17.1351 11.7109C16.4421 11.2499 16.1881 10.6369 16.1621 9.74194C16.5431 9.76594 16.8811 9.66394 17.1351 9.46094Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_82"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask81_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_160",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask81_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_161",
    d: "M17.1347 11.7375C17.1307 11.7375 17.1227 11.7335 17.1187 11.7335C16.4607 11.2885 16.1657 10.6945 16.1367 9.74152C16.1997 9.71852 16.2307 9.7185 16.2677 9.7215C16.5977 9.7215 16.8907 9.61952 17.1197 9.43652C17.4107 9.63952 17.7327 9.7415 18.1057 9.7175C18.1017 10.6945 17.8087 11.2875 17.1487 11.7335C17.1407 11.7335 17.1367 11.7375 17.1347 11.7375ZM16.1597 9.7655C16.2127 10.6715 16.4997 11.2495 17.1347 11.6835C17.7737 11.2495 18.0587 10.6715 18.0837 9.74252C18.0737 9.76952 18.0367 9.7695 18.0037 9.7695C17.6677 9.7695 17.3627 9.6675 17.1187 9.4765C16.9137 9.6675 16.6087 9.7695 16.2667 9.7695C16.2297 9.7695 16.1947 9.7695 16.1597 9.7655Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_83"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask82_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_162",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask82_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_163",
    d: "M17.1353 11.6045C17.6743 11.2495 17.9792 10.6355 18.0082 9.81552C17.6742 9.81552 17.3383 9.74152 17.1353 9.56152C16.9033 9.74152 16.5983 9.81552 16.2393 9.81552C16.2893 10.6365 16.5983 11.2495 17.1353 11.6045Z",
    fill: "#F0C727"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_84"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask83_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_164",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_165",
    d: "M17.135 11.6408C17.127 11.6408 17.119 11.6368 17.117 11.6368C16.572 11.2698 16.258 10.6409 16.207 9.82085C16.207 9.80885 16.211 9.80085 16.217 9.79385C16.221 9.78585 16.229 9.78185 16.239 9.78185C16.616 9.78185 16.903 9.69985 17.114 9.53585C17.128 9.52785 17.141 9.52785 17.157 9.53985C17.335 9.69185 17.641 9.78185 18.009 9.78185C18.017 9.78185 18.027 9.78585 18.03 9.79385C18.038 9.80185 18.042 9.80985 18.042 9.82085C18.013 10.6369 17.704 11.2698 17.153 11.6368C17.148 11.6368 17.141 11.6408 17.135 11.6408ZM16.272 9.84383C16.331 10.6248 16.627 11.2188 17.135 11.5738C17.649 11.2188 17.944 10.6248 17.973 9.84383C17.75 9.83983 17.381 9.80483 17.135 9.60583C16.916 9.76183 16.637 9.83983 16.272 9.84383Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_85"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask84_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_166",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask84_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_167",
    d: "M16.2646 12.8902C16.4716 12.9132 16.6996 12.9372 16.8816 12.9132C16.9836 12.9132 17.0556 13.0892 16.8566 13.1202C16.6746 13.1402 16.3916 13.1202 16.2396 13.0892C16.1106 13.0662 15.8296 13.0152 15.6496 12.9642C15.4716 12.8902 15.5986 12.7342 15.7006 12.7572C15.8576 12.8082 16.0606 12.8582 16.2646 12.8902Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_86"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask85_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_168",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g169 || (_g169 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask85_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_169",
    d: "M16.6777 13.1598C16.5137 13.1598 16.3357 13.1438 16.2347 13.1248C16.1097 13.1018 15.8227 13.0468 15.6407 12.9958C15.5177 12.9448 15.5218 12.8708 15.5278 12.8398C15.5438 12.7738 15.6077 12.7188 15.6757 12.7188C15.8147 12.7578 16.0217 12.8207 16.2677 12.8517C16.4277 12.8747 16.6878 12.9028 16.8768 12.8828C16.9488 12.8828 17.0117 12.9418 17.0157 13.0078C17.0177 13.0668 16.9787 13.1327 16.8597 13.1487C16.8047 13.1557 16.7417 13.1598 16.6777 13.1598ZM15.6877 12.7928C15.6407 12.7928 15.6017 12.8197 15.5937 12.8517C15.5817 12.8947 15.6327 12.9177 15.6617 12.9337C15.8397 12.9847 16.1227 13.0357 16.2457 13.0547C16.3827 13.0857 16.6657 13.1058 16.8477 13.0858C16.9137 13.0778 16.9498 13.0467 16.9458 13.0117C16.9458 12.9847 16.9167 12.9458 16.8817 12.9458C16.6997 12.9728 16.4247 12.9458 16.2587 12.9188C16.0077 12.8908 15.7927 12.8238 15.6877 12.7928Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_87"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask86_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g170 || (_g170 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_170",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g171 || (_g171 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask86_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_171",
    d: "M18.0086 12.8902C17.7976 12.9132 17.5706 12.9372 17.3916 12.9132C17.2886 12.9132 17.2156 13.0892 17.4146 13.1202C17.5946 13.1402 17.8776 13.1202 18.0296 13.0892C18.1606 13.0662 18.4396 13.0152 18.6216 12.9642C18.8016 12.8902 18.6726 12.7342 18.5706 12.7572C18.4146 12.8082 18.2116 12.8582 18.0086 12.8902Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_88"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask87_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g172 || (_g172 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_172",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g173 || (_g173 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask87_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_173",
    d: "M17.5922 13.1592C17.5262 13.1592 17.4652 13.1552 17.4142 13.1472C17.2892 13.1312 17.2502 13.0651 17.2542 13.0061C17.2582 12.9401 17.3222 12.8811 17.3912 12.8811C17.5922 12.9011 17.8422 12.8732 18.0002 12.8502C18.2442 12.8192 18.4532 12.7562 18.5592 12.7252C18.6572 12.7092 18.7312 12.7721 18.7412 12.8381C18.7492 12.8691 18.7512 12.9432 18.6362 12.9942C18.4482 13.0452 18.1612 13.0992 18.0382 13.1232C17.9322 13.1442 17.7542 13.1592 17.5922 13.1592ZM17.3892 12.9442C17.3562 12.9442 17.3232 12.9831 17.3192 13.0101C17.3192 13.0451 17.3562 13.0762 17.4212 13.0842C17.6032 13.1042 17.8862 13.0841 18.0262 13.0531C18.1472 13.0331 18.4322 12.9832 18.6142 12.9322C18.6352 12.9162 18.6822 12.8932 18.6772 12.8502C18.6692 12.8192 18.6302 12.7912 18.5932 12.7912C18.4782 12.8222 18.2592 12.8892 18.0132 12.9162C17.8342 12.9442 17.5762 12.9722 17.3892 12.9442Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_89"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask88_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g174 || (_g174 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_174",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g175 || (_g175 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask88_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_175",
    d: "M15.625 12.7887C15.471 12.7577 15.395 12.9367 15.445 13.0427C15.47 12.9877 15.5759 12.9877 15.5969 12.9377C15.6249 12.8587 15.576 12.8587 15.625 12.7887Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_90"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask89_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g176 || (_g176 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_176",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g177 || (_g177 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask89_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_177",
    d: "M15.4452 13.0732C15.4332 13.0732 15.4231 13.0651 15.4161 13.0531C15.3831 12.9941 15.3911 12.9051 15.4301 12.8421C15.4671 12.7831 15.5281 12.7441 15.5941 12.7441C15.6061 12.7481 15.6331 12.7561 15.6371 12.7711C15.6451 12.7791 15.6592 12.7942 15.6572 12.8022C15.6342 12.8332 15.6371 12.8411 15.6371 12.8571C15.6411 12.8801 15.6451 12.9001 15.6291 12.9431C15.6111 12.9901 15.5681 13.0022 15.5351 13.0172C15.5101 13.0292 15.4802 13.0402 15.4762 13.0522C15.4712 13.0652 15.4632 13.0772 15.4452 13.0732ZM15.5681 12.8232C15.5211 12.8352 15.5002 12.8581 15.4882 12.8821C15.4702 12.9051 15.4632 12.9451 15.4632 12.9761C15.4772 12.9681 15.4962 12.9601 15.5102 12.9561C15.5352 12.9441 15.5611 12.9361 15.5651 12.9211C15.5771 12.8981 15.5731 12.8901 15.5691 12.8741C15.5681 12.8541 15.5651 12.8432 15.5681 12.8232Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_91"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask90_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g178 || (_g178 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_178",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g179 || (_g179 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask90_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_179",
    d: "M16.2382 13.2575C16.2382 13.1525 16.3402 13.1675 16.3402 13.0665C16.3402 13.0155 16.3152 12.9375 16.2642 12.9375C16.2112 12.9375 16.1622 12.9885 16.1622 13.0425C16.1372 13.1405 16.2382 13.1515 16.2382 13.2575Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_92"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask91_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g180 || (_g180 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_180",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g181 || (_g181 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask91_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_181",
    d: "M16.2382 13.2924C16.2202 13.2924 16.2072 13.2764 16.2072 13.2574C16.2072 13.2224 16.1872 13.1984 16.1702 13.1754C16.1452 13.1404 16.1112 13.1014 16.1272 13.0304C16.1272 12.9674 16.1912 12.9014 16.2642 12.9014C16.3402 12.9014 16.3772 12.9994 16.3772 13.0654C16.3772 13.1314 16.3402 13.1634 16.3142 13.1864C16.2892 13.2064 16.2752 13.2213 16.2752 13.2563C16.2752 13.2763 16.2582 13.2924 16.2382 13.2924ZM16.2642 12.9724C16.2292 12.9724 16.1962 13.0074 16.1962 13.0424C16.1882 13.0894 16.2042 13.1054 16.2212 13.1324C16.2292 13.1404 16.2352 13.1484 16.2422 13.1594C16.2502 13.1474 16.2622 13.1434 16.2672 13.1364C16.2922 13.1164 16.3082 13.1053 16.3082 13.0663C16.3092 13.0223 16.2812 12.9724 16.2642 12.9724Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_93"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask92_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g182 || (_g182 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_182",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g183 || (_g183 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask92_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_183",
    d: "M16.9713 12.9648C17.1193 12.9648 17.1063 13.1678 17.0343 13.2698C17.0343 13.1998 16.9033 13.1679 16.9033 13.1219C16.9023 13.0429 17.0183 13.0428 16.9713 12.9648Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_94"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask93_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g184 || (_g184 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g185 || (_g185 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask93_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    d: "M17.0331 13.3047C17.0291 13.3047 17.0251 13.3047 17.0211 13.3007C17.0071 13.3007 16.9991 13.2847 16.9991 13.2697C16.9991 13.2497 16.9662 13.2307 16.9362 13.2067C16.9052 13.1837 16.8682 13.1557 16.8682 13.1207C16.8682 13.0657 16.9012 13.0387 16.9272 13.0187C16.9192 13.0067 16.9272 12.9757 16.9312 12.9637C16.9372 12.9517 16.9562 12.9287 16.9702 12.9287C17.0292 12.9287 17.0752 12.9557 17.1012 13.0067C17.1402 13.0927 17.1132 13.2137 17.0622 13.2917C17.0552 13.3007 17.0431 13.3047 17.0331 13.3047ZM17.0161 13.0077C17.0121 13.0427 16.9872 13.0587 16.9712 13.0737C16.9492 13.0897 16.9381 13.1007 16.9381 13.1207C16.9421 13.1247 16.9652 13.1407 16.9792 13.1477C16.9972 13.1597 17.0181 13.1747 17.0381 13.1947C17.0561 13.1397 17.0592 13.0777 17.0402 13.0387C17.0372 13.0267 17.0251 13.0157 17.0161 13.0077Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_95"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask94_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g186 || (_g186 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_186",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g187 || (_g187 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask94_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_187",
    d: "M18.6436 12.7887C18.8016 12.7577 18.8756 12.9367 18.8256 13.0427C18.8026 12.9877 18.6946 12.9877 18.6736 12.9377C18.6436 12.8587 18.6936 12.8587 18.6436 12.7887Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_96"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask95_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g188 || (_g188 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_188",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g189 || (_g189 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask95_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_189",
    d: "M18.824 13.0733C18.808 13.0733 18.799 13.0653 18.791 13.0533C18.787 13.0413 18.758 13.0303 18.732 13.0183C18.699 13.0023 18.656 12.9913 18.638 12.9483C18.624 12.9013 18.628 12.8823 18.63 12.8583C18.634 12.8423 18.634 12.8353 18.616 12.8033C18.608 12.7953 18.608 12.7833 18.612 12.7723C18.616 12.7603 18.624 12.7523 18.633 12.7493C18.746 12.7453 18.799 12.7843 18.836 12.8433C18.877 12.9063 18.883 12.9953 18.85 13.0543C18.85 13.0653 18.838 13.0733 18.824 13.0733ZM18.699 12.8193C18.703 12.8393 18.699 12.8543 18.699 12.8743C18.697 12.8903 18.693 12.8973 18.703 12.9253C18.707 12.9373 18.736 12.9453 18.762 12.9563C18.778 12.9603 18.791 12.9683 18.805 12.9763C18.809 12.9453 18.799 12.9063 18.782 12.8823C18.77 12.8583 18.74 12.8273 18.699 12.8193Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_97"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask96_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g190 || (_g190 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_190",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g191 || (_g191 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask96_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_191",
    d: "M18.0287 13.2575C18.0287 13.1525 17.9268 13.1675 17.9268 13.0665C17.9268 13.0155 17.9557 12.9375 18.0067 12.9375C18.0577 12.9375 18.1088 12.9885 18.1088 13.0425C18.1308 13.1405 18.0287 13.1515 18.0287 13.2575Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_98"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask97_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g192 || (_g192 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_192",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g193 || (_g193 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask97_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_193",
    d: "M18.0295 13.2923C18.0115 13.2923 17.9965 13.2763 17.9965 13.2573C17.9965 13.2223 17.9785 13.2063 17.9575 13.1873C17.9325 13.1643 17.8945 13.1323 17.8945 13.0663C17.8945 13.0003 17.9315 12.9023 18.0075 12.9023C18.0755 12.9023 18.1465 12.9683 18.1465 13.0433C18.1565 13.1023 18.1265 13.1413 18.0975 13.1763C18.0795 13.1993 18.0665 13.2233 18.0665 13.2583C18.0665 13.2763 18.0475 13.2923 18.0295 13.2923ZM18.0085 12.9723C17.9865 12.9723 17.9615 13.0233 17.9615 13.0663C17.9615 13.1053 17.9795 13.1173 18.0005 13.1363C18.0085 13.1443 18.0205 13.1483 18.0255 13.1593C18.0335 13.1473 18.0415 13.1393 18.0475 13.1323C18.0705 13.1053 18.0845 13.0893 18.0745 13.0463C18.0745 13.0073 18.0375 12.9723 18.0085 12.9723Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_99"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask98_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g194 || (_g194 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_194",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g195 || (_g195 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask98_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_195",
    d: "M17.3012 12.9648C17.1492 12.9648 17.1642 13.1678 17.2362 13.2698C17.2362 13.1998 17.3672 13.1679 17.3672 13.1219C17.3672 13.0429 17.2502 13.0428 17.3012 12.9648Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_100"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask99_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g196 || (_g196 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_196",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g197 || (_g197 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask99_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_197",
    d: "M17.2357 13.3047C17.2237 13.3047 17.2147 13.3007 17.2067 13.2927C17.1557 13.2147 17.1227 13.0937 17.1677 13.0077C17.1907 12.9567 17.2377 12.9297 17.3007 12.9297C17.3127 12.9297 17.3217 12.9377 17.3297 12.9457C17.3337 12.9617 17.3337 12.9727 17.3257 12.9847C17.3667 13.0397 17.3977 13.0667 17.3977 13.1217C17.3977 13.1567 17.3627 13.1847 17.3297 13.2077C17.3007 13.2307 17.2707 13.2507 17.2707 13.2707C17.2707 13.2867 17.2607 13.3017 17.2457 13.3017C17.2417 13.3047 17.2377 13.3047 17.2357 13.3047ZM17.2537 13.0077C17.2417 13.0157 17.2357 13.0277 17.2287 13.0387C17.2077 13.0777 17.2147 13.1407 17.2367 13.1947C17.2507 13.1747 17.2717 13.1597 17.2897 13.1477C17.3057 13.1397 17.3267 13.1247 17.3307 13.1207C17.3307 13.1007 17.3187 13.0897 17.2977 13.0737C17.2827 13.0587 17.2577 13.0427 17.2537 13.0077Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_101"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask100_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g198 || (_g198 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_198",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g199 || (_g199 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask100_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_199",
    d: "M15.6758 12.8398C15.7268 12.8398 15.8048 12.8598 15.8278 12.8908L15.6758 12.8398Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_102"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask101_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g200 || (_g200 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_200",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g201 || (_g201 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask101_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_201",
    d: "M15.8285 12.9095C15.8265 12.9095 15.8225 12.9095 15.8225 12.9055L15.6705 12.8585C15.6585 12.8545 15.6525 12.8425 15.6565 12.8355C15.6565 12.8195 15.6665 12.8125 15.6765 12.8125C15.7275 12.8125 15.8155 12.8355 15.8485 12.8755C15.8565 12.8835 15.8565 12.8955 15.8485 12.9025C15.8445 12.9055 15.8365 12.9095 15.8285 12.9095Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_103"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask102_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g202 || (_g202 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__95"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_202",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g203 || (_g203 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask102_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_203",
    d: "M15.9297 12.9141C15.9587 12.9141 16.0607 12.9371 16.1097 12.9651L15.9297 12.9141Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_104"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask103_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g204 || (_g204 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_204",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g205 || (_g205 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask103_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_205",
    d: "M16.1093 12.9914C16.1093 12.9914 16.1053 12.9914 16.1053 12.9874L15.9232 12.9364C15.9112 12.9324 15.9062 12.9204 15.9062 12.9094C15.9123 12.8704 16.0512 12.9014 16.1232 12.9444C16.1332 12.9484 16.1372 12.9604 16.1332 12.9714C16.1272 12.9834 16.1193 12.9914 16.1093 12.9914Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_105"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask104_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g206 || (_g206 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_206",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g207 || (_g207 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask104_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_207",
    d: "M16.8549 13.0156C16.7999 13.0156 16.6989 13.0156 16.6729 13.0426L16.8549 13.0156Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_106"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask105_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g208 || (_g208 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_208",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g209 || (_g209 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask105_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_209",
    d: "M16.674 13.0621C16.664 13.0621 16.657 13.0541 16.649 13.0461C16.645 13.0421 16.6491 13.0301 16.6571 13.0231C16.6841 12.9961 16.755 12.9961 16.856 12.9961C16.866 12.9961 16.878 13.0001 16.878 13.0121C16.878 13.0281 16.866 13.0391 16.86 13.0431L16.678 13.0631H16.674V13.0621Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_107"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask106_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g210 || (_g210 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_210",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g211 || (_g211 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask106_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_211",
    d: "M16.5726 13.0154C16.5436 12.9884 16.4416 12.9884 16.3906 13.0154H16.5726Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_108"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask107_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g212 || (_g212 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_212",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g213 || (_g213 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask107_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_213",
    d: "M16.5717 13.043H16.3897C16.3797 13.043 16.3717 13.035 16.3687 13.023C16.3647 13.011 16.3687 13 16.3807 12.996C16.4277 12.973 16.5287 12.937 16.5897 12.996C16.5937 13.004 16.5977 13.016 16.5937 13.027C16.5897 13.035 16.5797 13.043 16.5717 13.043Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_109"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask108_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g214 || (_g214 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_214",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g215 || (_g215 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask108_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_215",
    d: "M18.5924 12.8398C18.5414 12.8398 18.4694 12.8598 18.4404 12.8908L18.5924 12.8398Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_110"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask109_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g216 || (_g216 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_216",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g217 || (_g217 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask109_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_217",
    d: "M18.4406 12.9095C18.4326 12.9095 18.4266 12.9015 18.4226 12.8975C18.4146 12.8935 18.4146 12.8775 18.4266 12.8705C18.4576 12.8395 18.5416 12.8115 18.5926 12.8115C18.6066 12.8115 18.6176 12.8195 18.6176 12.8345C18.6176 12.8425 18.6136 12.8545 18.6016 12.8575L18.4476 12.9045C18.4476 12.9095 18.4436 12.9095 18.4406 12.9095Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_111"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask110_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g218 || (_g218 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_218",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g219 || (_g219 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask110_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_219",
    d: "M18.3382 12.9141C18.3092 12.9141 18.2112 12.9371 18.1602 12.9651L18.3382 12.9141Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_112"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask111_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g220 || (_g220 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_220",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g221 || (_g221 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask111_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_221",
    d: "M18.16 12.9914C18.148 12.9914 18.142 12.9834 18.139 12.9714C18.131 12.9594 18.139 12.9444 18.149 12.9444C18.227 12.9014 18.356 12.8704 18.364 12.9094C18.368 12.9214 18.36 12.9324 18.346 12.9364L18.168 12.9874C18.164 12.9914 18.164 12.9914 18.16 12.9914Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_113"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask112_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g222 || (_g222 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_222",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g223 || (_g223 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask112_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_223",
    d: "M17.4141 13.0156C17.4691 13.0156 17.5701 13.0156 17.5941 13.0426L17.4141 13.0156Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_114"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask113_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g224 || (_g224 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_224",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g225 || (_g225 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask113_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_225",
    d: "M17.5936 13.0621L17.4136 13.0421C17.3976 13.0381 17.3906 13.0261 17.3906 13.0111C17.3906 12.9991 17.4026 12.9951 17.4136 12.9951C17.5186 12.9951 17.5836 12.9951 17.6126 13.0221C17.6206 13.0301 17.6226 13.0421 17.6206 13.0451C17.6166 13.0541 17.6046 13.0621 17.5936 13.0621Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_115"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask114_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g226 || (_g226 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_226",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g227 || (_g227 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask114_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_227",
    d: "M17.6953 13.0154C17.7243 12.9884 17.8263 12.9884 17.8773 13.0154H17.6953Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_116"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask115_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g228 || (_g228 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_228",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g229 || (_g229 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask115_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_229",
    d: "M17.8776 13.043H17.6956C17.6896 13.043 17.6776 13.035 17.6736 13.027C17.6716 13.015 17.6736 13.004 17.6816 12.996C17.7426 12.937 17.8436 12.973 17.8886 12.996C17.8986 13 17.9026 13.012 17.8986 13.023C17.8986 13.035 17.8896 13.043 17.8776 13.043Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_117"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask116_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g230 || (_g230 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_230",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g231 || (_g231 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask116_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_231",
    d: "M17.4925 7.97226C17.4415 7.84726 17.3515 7.74226 17.2245 7.71426C17.1635 7.70226 17.0975 7.70227 17.0215 7.70227C16.9455 7.68227 16.8805 7.76528 16.8555 7.81528C16.9315 7.87028 16.9495 7.92427 16.9885 7.94427C17.0685 7.97127 17.1055 7.94427 17.1855 7.87027C17.2665 7.79627 17.4415 7.81526 17.4925 7.97226Z",
    fill: "#F0C727"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_118"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask117_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g232 || (_g232 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_232",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g233 || (_g233 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask117_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_233",
    d: "M17.0428 7.9726C17.0248 7.9726 17.0038 7.9686 16.9818 7.9566C16.9608 7.9526 16.9448 7.92961 16.9268 7.90561C16.9058 7.88261 16.8838 7.85861 16.8428 7.82761C16.8548 7.78061 16.9128 7.68262 16.9948 7.68262L17.0648 7.68661C17.1428 7.68261 17.1858 7.69061 17.2308 7.70261C17.3358 7.72261 17.4258 7.8046 17.4888 7.9216C17.3868 7.8556 17.2598 7.8166 17.1938 7.8826C17.1368 7.9376 17.0978 7.9726 17.0428 7.9726ZM17.0158 7.7186C16.9418 7.7186 16.8948 7.77361 16.8658 7.82361C16.9068 7.83561 16.9318 7.8626 16.9498 7.8866C16.9678 7.9066 16.9788 7.9216 16.9968 7.9296C17.0628 7.9526 17.0908 7.93759 17.1748 7.85959C17.2338 7.80459 17.3448 7.80059 17.4188 7.85159C17.3598 7.78859 17.2978 7.74959 17.2258 7.73459C17.1828 7.72259 17.1418 7.7186 17.1028 7.7186H17.0228C17.0178 7.7186 17.0178 7.7186 17.0158 7.7186Z",
    fill: "#F0C727"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_119"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask118_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g234 || (_g234 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_234",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g235 || (_g235 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask118_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_235",
    d: "M17.004 7.77637C16.957 7.77637 16.957 7.85437 17.004 7.85437C17.055 7.85437 17.055 7.77637 17.004 7.77637Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_120"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask119_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g236 || (_g236 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_236",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g237 || (_g237 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask119_11472_29617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_237",
    d: "M17.0036 7.88648C16.9646 7.88648 16.9316 7.85548 16.9316 7.81248C16.9316 7.73048 17.0796 7.73048 17.0796 7.81248C17.0796 7.85448 17.0466 7.88648 17.0036 7.88648Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_121"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask120_11472_29617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g238 || (_g238 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000072252331280634568600000002834902716932786594__113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_238",
    d: "M34.1011 0.976562H0.537109V20.5546H34.1011V0.976562Z",
    fill: "white"
  })))), _g239 || (_g239 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask120_11472_29617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_239",
    d: "M17.4453 9.72952V11.3425C17.3553 11.4405 17.2503 11.5335 17.1343 11.6045C17.0173 11.5345 16.9133 11.4405 16.8213 11.3425V9.72552C16.9343 9.68252 17.0423 9.62752 17.1343 9.56152C17.2213 9.63252 17.3263 9.68752 17.4453 9.72952Z",
    fill: "white"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgypt);
export default __webpack_public_path__ + "static/media/EGYPT.559c4cf04988bc69bce5fc3ce9d816ba.svg";
export { ForwardRef as ReactComponent };